import mySecureStorage from "./secure-storage.js";

export const getItem = (keys) => {
  if (!Array.isArray(keys)) {
    let key = keys;
    return mySecureStorage.getItem(key);
  }

  let item = mySecureStorage.getItem(keys[0]) || {};
  let value;

  if (keys.length > 1) {
    let otherKeys = keys.slice(1);
    for (let key of otherKeys) {
      value = item[key];
      item = item[key] ?? {};
    }
  }

  return value;
};

export const setItem = (keys, value) => {
  if (!Array.isArray(keys)) {
    let key = keys;
    return mySecureStorage.setItem(key, value);
  }

  let currentValue = mySecureStorage.getItem(keys[0]) || {};
  let newValue = {};

  const otherKeys = keys.slice(1);
  let currentObj = newValue;

  for (let i = 0; i < otherKeys.length - 1; i++) {
    currentObj[otherKeys[i]] = {};
    currentObj = currentObj[otherKeys[i]];
  }
  currentObj[otherKeys[otherKeys.length - 1]] = value;

  mySecureStorage.setItem(keys[0], { ...currentValue, ...newValue });
};

export const clear = () => localStorage.clear();
